import { HOST_URL } from '~/constants/config';
let intervalProcess;
/**
 * Generate video object for tracking
 */
const generateVideoObj = (player, route) => {
  const { path } = route.value || route;
  const playerObj = player.value || player;
  return {
    video_duration: playerObj.duration().toFixed(0),
    video_current_time: playerObj.currentTime().toFixed(0),
    video_percent: playerObj.currentTime() !== 0 ? ((playerObj.currentTime() * 100) / playerObj.duration()).toFixed(0) : '0',
    video_url: `${HOST_URL}${path}`,
    video_provider: 'Onedio',
  };
};

/**
 * Run gtag integration
 * @param {STRING} event
 * @param {OBJECT} data
 */
export const integrationGtag = (event, args) => {
  const { data = {}, player, route } = args;
  if (event === 'video_playing') {
    intervalProcess = setInterval(() => {
      window.dataLayer.push({ event, ...generateVideoObj(player, route), ...data });
    }, 10 * 1000);
  } else {
    window.dataLayer.push({ event, ...generateVideoObj(player, route), ...data });
  }
};

/**
 * Stop the video interval
 */
export const stopVideoInterval = () => {
  clearInterval(intervalProcess);
  intervalProcess = null;
};
